import * as React from 'react';

import * as styles from './styles.css';

interface ISectionProps {
  children: React.ReactNode;
  dataMark?: string;
  padded?: boolean;
}

export function Section({ children, dataMark, padded = true, ...divProps }: ISectionProps): React.JSX.Element {
  return (
    <section {...divProps} data-mark={dataMark} className={styles['section']} data-padded={padded}>
      {children}
    </section>
  );
}
